import { RootState } from '../../../../src/app';

export const selectTasklists = ({ tasks }: RootState) => tasks.tasklists;

export const selectTasklistsById = ({ tasks }: RootState, id: string) => {
  return tasks.tasklists[id];
};
